export default __webpack_public_path__ + "static/media/mtn 1.0d358277.svg";